import Axios from "api/Axios/authAxios";
import appAxios from "api/Axios/index";

// ! Deprecated
// export const register = async (payload) => {
//     const response = await Axios.post(`/auth/register`, payload);
//     return response.data;
// }

// Onboard Tenant registration
export const onboardTenant = async (payload) => {
    const response = await Axios.post(`/tenant/onboard`, payload);
    return response.data;
}

// Login
export const login = async (payload) => {
    const response = await Axios.post(`/login`, payload);
    return response.data;
}

export const verifyTenant = async (payload) => {
    const response = await Axios.get(`/tenant/`, { params: payload });
    return response.data;
}

export const logout = async (payload) => {
    const response = await Axios.post(`/auth/logout`, payload);
    return response.data;
}

export const getProfileInfo = async () => {
    const response = await Axios.get(`/`);
    return response.data;
}

export const forgotPassword = async (payload) => {
    const response = await Axios.post(`/forgot-password-send-temp-password`, payload);
    return response.data;
}

export const changePassword = async (payload) => {
    const response = await Axios.post(`/change-password`, payload);
    return response.data;
}

// Get Google Auth URL
export const getGoogleAuthUrl = async (payload) => {   
    const response = await appAxios.get('/auth/google', { params: payload });
    return response.data;
};

// Exchange Google code & token for login/signup
export const exchangeGoogleCode = async (payload) => {
    const response = await appAxios.get('/auth/google/redirect', { params: payload });
    return response.data;
};
